<template>
    <el-dialog
        class="new_service_dialog"
        :title="title"
        :visible.sync="openNewServiceDialog"
        top="4%"
        width="40%"
        style="padding: 0 50px 50px 0;"
        :before-close="closeDialog">
        <el-form ref="form" :model="form" :rules="rules" label-width="180px" size="mini">
            <el-form-item
                v-if="row.propertyNature === PERSON"
                prop="principalName" label="负责人姓名" style="width:100%;">
                <el-input v-model="row.principalName" :disabled="true" @blur="handleUpdateForm"></el-input>
            </el-form-item>
            <el-form-item
                v-if="[COMPANY, ABROAD, ORGANIZATION, HKMCTW].includes(row.propertyNature)"
                prop="supplierNameCn" label="供应商名称" style="width:100%;">
                <el-input v-model="row.supplierNameCn" :disabled="true" @blur="handleUpdateForm"></el-input>
            </el-form-item>
            <el-form-item prop="supplierType" label="供应商类型" style="width:100%;">
                <el-input v-model="row.supplierTypeName" :disabled="true" class="normal_input"></el-input>
            </el-form-item>
            <el-form-item prop="propertyNature" label="主体性质" style="width:100%;">
                <el-input v-model="row.propertyNature_" :disabled="true" class="normal_input"></el-input>
            </el-form-item>
            <el-form-item
                v-if="row.supplierType === LOGISTICS_SUPPLIER || row.supplierType === INNER_SUPPLIER"
                prop="isOverseas"
                label="涉外业务类型"
                style="width:100%;"
            >
                <MSelect
                    :value="form.isOverseas"
                    :optionNum="'SRM_IS_OVERSEAS'"
                    :disabled="row.supplierType === INNER_SUPPLIER"
                    @input="handleOSChange"
                ></MSelect>
            </el-form-item>
            <el-form-item
                v-if="row.supplierType === LOGISTICS_SUPPLIER || row.supplierType === INNER_SUPPLIER"
                prop="businessType" label="业务类型" style="width:100%;">
                <el-select v-model="form.businessType" class="normal_input" @change="handleUpdateForm">
                    <el-option
                        v-for="item in options.businessTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="[TRANSPORTATION_NUM, DS_NUM, BG_NUM].includes(form.businessType)
                    && (row.supplierType === LOGISTICS_SUPPLIER || row.supplierType === INNER_SUPPLIER)
                    && options.transportTypeOptions.length"
                prop="transportType" label="运输方式" style="width:100%;">
                <el-select v-model="form.transportType" class="normal_input" @change="handleUpdateForm">
                    <el-option
                        v-for="item in options.transportTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="(form.businessType === EXPRESS_NUM
                                || form.businessType === HOME_DELIVERY_NUM
                                || form.businessType === DISPATCH_NUM
                                || (form.transportType && form.businessType === TRANSPORTATION_NUM)
                                || form.transportType === TPT_OTHER_NUM
                                || form.transportType === TPT_BG_NUM
                                || form.transportType === TPT_DS_NUM)
                                &&(row.supplierType === LOGISTICS_SUPPLIER || row.supplierType === INNER_SUPPLIER)
                                && options.transTypeOptions.length"
                prop="transType" label="承运商类别" style="width:100%;">
                <el-select v-model="form.transType" class="normal_input" @change="handleUpdateForm">
                    <el-option
                        v-for="item in options.transTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="form.businessType === STORAGE_NUM
                    && (row.supplierType === LOGISTICS_SUPPLIER || row.supplierType === INNER_SUPPLIER)
                    && options.corporateTypeOptions.length"
                prop="corporateType" label="合作方式" style="width:100%;">
                <el-select v-model="form.corporateType" class="normal_input" @change="handleUpdateForm">
                    <el-option
                        v-for="item in options.corporateTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="form.businessType === STORAGE_NUM
                    && (form.corporateType === LEASING_STORAGE_NUM || form.corporateType === LEASING_STORAGE_LEASE_NUM)
                    && (row.supplierType === LOGISTICS_SUPPLIER || row.supplierType === INNER_SUPPLIER)
                    && options.lesseeTypeOptions.length"
                prop="lesseeType" label="租赁商类别" style="width:100%;">
                <el-select v-model="form.lesseeType" class="normal_input" @change="handleUpdateForm">
                    <el-option
                        v-for="item in options.lesseeTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" :loading="loading" @click="handleSubmit">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
import MSelect from '@/components/lots/otpSelect2/index';
import { NOT_INVOLVE } from '../../../../constant/constant.js';
import {
    PERSON,
    COMPANY,
    ABROAD,
    ORGANIZATION,
    HKMCTW,
    LOGISTICS_SUPPLIER,
    INNER_SUPPLIER,
    TRANSPORTATION_NUM,
    EXPRESS_NUM,
    STORAGE_NUM,
    SEA_TRANSPORTATION_NUM,
    LEASING_STORAGE_NUM,
    LEASING_STORAGE_LEASE_NUM,
    HOME_DELIVERY_NUM,
    DS_NUM,
    BG_NUM,
    DISPATCH_NUM,
    TPT_OTHER_NUM,
    TPT_BG_NUM,
    TPT_DS_NUM,
} from '../../../../constant/supplierListConstant.js';
import { dictWithUrl } from '@/components/lots/api';
import { chooseSupplierType, chooseBusinessType, chooseTransport, confirmSupplierType } from '../../../../api/register/supplierList.js';
import { getSysControlParamByCode } from '../../../../api/toDo/sysParamsConfig.js';

const DELEGATE_MSG = '法人供应商新增运输或配送业务，原签署线下委派函的司机将会在次日凌晨停用，需重新签署线上委派函才可启用。 如接受司机停用，则点击“确认”新增业务，否则点击“取消”。'

export default {
    name: 'add-or-edit-dialog',
    components: { MSelect },
    props: {
        openNewServiceDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        row: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            PERSON,
            COMPANY,
            ABROAD,
            ORGANIZATION,
            HKMCTW,
            LOGISTICS_SUPPLIER,
            INNER_SUPPLIER,
            // OS_LGT,
            TRANSPORTATION_NUM,
            EXPRESS_NUM,
            STORAGE_NUM,
            SEA_TRANSPORTATION_NUM,
            LEASING_STORAGE_NUM,
            LEASING_STORAGE_LEASE_NUM,
            HOME_DELIVERY_NUM,
            DS_NUM,
            BG_NUM,
            DISPATCH_NUM,
            TPT_OTHER_NUM,
            TPT_BG_NUM,
            TPT_DS_NUM,
            title: '新增服务申请',
            // allow: false,
            form: {
                supplierNameCn: '',
                principalName: '',
                supplierType: '',
                propertyNature: '',
                isOverseas: '',
                businessType: '',
                transportType: '',
                transType: '', // 业务类型控制承运商类别
                corporateType: '',
                lesseeType: ''
            },
            submitForm: {},
            options: {
                supplierTypeOptions: [],
                propertyNatureOptions: [],
                businessTypeOptions: [],
                transportTypeOptions: [],
                transTypeOptions: [], // 业务类型控制承运商类别
                corporateTypeOptions: [],
                lesseeTypeOptions: [],
                businessTypeArr: [],
                corporateTypeArr: [],
                transTypeArr: [], // 业务类型控制承运商类别
                transportTypeArr: [],
                lesseeTypeArr: []
            },
            rules: {
                isOverseas: [
                    { required: true, message: '请选择涉外业务类型', trigger: ['blur', 'change'] }
                ],
                businessType: [
                    { required: true, message: '请选择业务类型', trigger: ['blur', 'change'] }
                ],
                transportType: [
                    { required: true, message: '请选择运输方式', trigger: ['blur', 'change'] }
                ],
                transType: [
                    { required: true, message: '请选择承运商类型', trigger: ['blur', 'change'] }
                ],
                corporateType: [
                    { required: true, message: '请选择合作方式', trigger: ['blur', 'change'] }
                ],
                lesseeType: [
                    { required: true, message: '请选择租赁商类别', trigger: ['blur', 'change'] }
                ]
            },
            loading: false
        };
    },
    methods: {
        handleUpdateForm() {
            if (this.row.supplierType && this.row.propertyNature) {
                const form = this.handleFormData();
                Object.keys(form).forEach(e => {
                    if (!form[e]) {
                        delete form[e];
                    }
                });
                this.submitForm = JSON.parse(JSON.stringify(form));
            }
        },
        handleFormData() {
            const list = ['principalName', 'supplierNameCn', 'isOverseas', 'businessType', 'transportType', 'transType', 'transType_', 'corporateType', 'lesseeType'];
            const form = {};
            const judge = {
                supplierNameCn: [COMPANY, ABROAD, ORGANIZATION, HKMCTW].includes(this.row.propertyNature),
                principalName: this.row.propertyNature === PERSON,
                isOverseas: [LOGISTICS_SUPPLIER, INNER_SUPPLIER].includes(this.row.supplierType),
                businessType: (this.row.supplierType === LOGISTICS_SUPPLIER || this.row.supplierType === INNER_SUPPLIER) &&
                    this.options.businessTypeOptions.length,
                transportType: [TRANSPORTATION_NUM, DS_NUM, BG_NUM].includes(this.form.businessType) &&
                    (this.row.supplierType === LOGISTICS_SUPPLIER || this.row.supplierType === INNER_SUPPLIER) &&
                    this.options.transportTypeOptions.length,
                transType: (this.form.businessType === EXPRESS_NUM ||
                    this.form.businessType === HOME_DELIVERY_NUM ||
                    this.form.businessType === DISPATCH_NUM ||
                    (this.form.transportType && this.form.businessType === TRANSPORTATION_NUM) ||
                    this.form.transportType === TPT_OTHER_NUM ||
                    this.form.transportType === TPT_BG_NUM ||
                    this.form.transportType === TPT_DS_NUM) &&
                    (this.row.supplierType === LOGISTICS_SUPPLIER || this.row.supplierType === INNER_SUPPLIER) &&
                    this.options.transTypeOptions.length,
                corporateType: this.form.businessType === STORAGE_NUM &&
                    (this.row.supplierType === LOGISTICS_SUPPLIER || this.row.supplierType === INNER_SUPPLIER) &&
                    this.options.corporateTypeOptions.length,
                lesseeType: this.form.businessType === STORAGE_NUM &&
                    (this.form.corporateType === LEASING_STORAGE_NUM || this.form.corporateType === LEASING_STORAGE_LEASE_NUM) &&
                    (this.row.supplierType === LOGISTICS_SUPPLIER || this.row.supplierType === INNER_SUPPLIER) &&
                    this.options.lesseeTypeOptions.length
            };
            list.forEach(e => {
                if (judge[e]) {
                    form[e] = this.form[e];
                }
            });
            form.propertyNature = this.form.propertyNature;
            form.supplierType = this.form.supplierType;
            return form;
        },
        clear() {
            this.form = {
                supplierNameCn: '',
                principalName: '',
                supplierType: '',
                propertyNature: '',
                isOverseas: '',
                businessType: '',
                transportType: '',
                transType: '',
                corporateType: '',
                lesseeType: ''
            }
            this.options.businessTypeOptions = []
            this.options.transportTypeOptions = []
            this.options.transTypeOptions = []
            this.options.corporateTypeOptions = []
            this.options.lesseeTypeOptions = []
        },
        closeDialog() {
            this.clear()
            this.$emit('closeDialog', false);
        },
        handleSubmit() {
            this.handleVerify(() => {
                // 物流供应商，法人，业务类型为 运输、配送时，检测是否二次确认提示信息
                if (this.row.supplierType === LOGISTICS_SUPPLIER && this.row.propertyNature === COMPANY && [TRANSPORTATION_NUM, DISPATCH_NUM].includes(this.submitForm.businessType)) {
                    this.loading = true
                    getSysControlParamByCode({ controlCode: 'isSatisfyCheckSupplierIsWhite' }).then(res => {
                        if (res && +res.code === 0) {
                            const message = res.data || DELEGATE_MSG
                            this.$confirm(message, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'info'
                            }).then(() => {
                                this.confirmDialog();
                            }).catch(() => {});
                        } else if (res && +res.code === 0 && !res.data) {
                            this.confirmDialog();
                        }
                    }).catch(err => {}).finally(() => { this.loading = false })
                } else {
                    this.confirmDialog();
                }
            });
        },
        confirmDialog() {
            this.handleFormData();
            const params = {
                supplierType: this.row.supplierType,
                propertyNature: this.row.propertyNature,
                supplierCode: this.row.supplierCode
            };
            this.loading = true;
            confirmSupplierType(Object.assign(params, this.submitForm)).then(res => {
                this.loading = false;
                if (res && +res.code === 0) {
                    this.$emit('confirmDialog', false);
                    // this.allow = false;
                    this.$router.push({
                        path: '/keyData/detail',
                        query: {
                            businessType: this.submitForm.businessType,
                            supplierCode: res.data
                        }
                    });
                }
            }).catch(e => { this.loading = false; });
        },
        handleVerify(callback) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    // this.allow = true;
                    callback()
                } else {
                    const duration = 2500;
                    setTimeout(() => {
                        this.$refs.form.clearValidate('supplierType');
                        this.$refs.form.clearValidate('propertyNature');
                        this.$refs.form.clearValidate('supplierNameCn');
                        this.$refs.form.clearValidate('principalName');
                        this.$refs.form.clearValidate('isOverseas');
                        this.$refs.form.clearValidate('businessType');
                        this.$refs.form.clearValidate('transportType');
                        this.$refs.form.clearValidate('transType');
                        this.$refs.form.clearValidate('corporateType');
                        this.$refs.form.clearValidate('lesseeType');
                    }, duration);
                }
            });
        },
        handleOSChange(val) {
            this.form.isOverseas = val;
            this.form.businessType = '';
            this.handleUpdateForm();
            this.getBusinessTypeOptions();
        },
        getBusinessTypeOptions() {
            const params = {
                supplierType: this.row.supplierType,
                propertyNature: this.row.propertyNature,
                isOverseas: this.form.isOverseas,
            };
            chooseSupplierType(params).then(res => {
                this.options.businessTypeOptions = [];
                if (res && +res.code === 0 && res.data && res.data.length) {
                    this.options.businessTypeArr.forEach(e => {
                        for (const i of new Set(res.data)) {
                            if (String(i) === e.value) {
                                this.options.businessTypeOptions.push(e);
                            }
                        }
                    });
                }
            });
        },
    },
    computed: {
        // updateForm() {
        //     return this.row.supplierType + this.row.propertyNature + Math.random();
        // },
        businessTypeForm() {
            return this.form.businessType;
        },
        corporateTypeForm() {
            return this.form.corporateType;
        },
        transportTypeForm() {
            return this.form.transportType;
        }
    },
    watch: {
        openNewServiceDialog(val) {
            if (this.$refs['form']) {
                this.$refs['form'].resetFields();
            }
            if (val) {
                // 内部供应商，涉外业务类型赋值
                if (this.row.supplierType === INNER_SUPPLIER) {
                    this.form.isOverseas = NOT_INVOLVE
                }
                this.getBusinessTypeOptions()
            }
        },
        // updateForm() {
        //     const params = {
        //         supplierType: this.row.supplierType,
        //         propertyNature: this.row.propertyNature,
        //         isOverseas: this.row.isOverseas,
        //     };
        //     chooseSupplierType(params).then(res => {
        //         this.options.businessTypeOptions = [];
        //         if (res && +res.code === 0 && res.data && res.data.length) {
        //             this.options.businessTypeArr.forEach(e => {
        //                 for (const i of new Set(res.data)) {
        //                     if (String(i) === e.value) {
        //                         this.options.businessTypeOptions.push(e);
        //                     }
        //                 }
        //             });
        //         }
        //     });
        // },
        businessTypeForm() {
            this.handleUpdateForm();
            const params = {
                supplierType: this.row.supplierType,
                propertyNature: this.row.propertyNature,
            };
            chooseBusinessType(Object.assign(params, this.submitForm)).then(res => {
                this.options.corporateTypeOptions = [];
                this.options.transportTypeOptions = [];
                this.options.transTypeOptions = [];
                if (res && +res.code === 0) {
                    if (+this.form.businessType === 1) {
                        this.options.corporateTypeArr.forEach(e => {
                            for (const i of new Set(res.data)) {
                                if (String(i) === e.value) {
                                    this.options.corporateTypeOptions.push(e);
                                }
                            }
                        });
                    }
                    if ([TRANSPORTATION_NUM, DS_NUM, BG_NUM].includes(this.form.businessType)) {
                        this.form.transportType = '';
                        this.options.transportTypeArr.forEach(e => {
                            for (const i of new Set(res.data)) {
                                if (String(i) === e.value) {
                                    this.options.transportTypeOptions.push(e);
                                }
                            }
                        });
                    }
                    if (this.form.businessType === '4' || this.form.businessType === EXPRESS_NUM || this.form.businessType === '10') {
                        this.form.transType = '';
                        this.options.transTypeArr.forEach(e => {
                            for (const i of new Set(res.data)) {
                                if (String(i) === e.value) {
                                    this.options.transTypeOptions.push(e);
                                }
                            }
                        });
                    }
                }
            });
        },
        corporateTypeForm() {
            this.handleUpdateForm();
            const params = {
                supplierType: this.row.supplierType,
                propertyNature: this.row.propertyNature
            };
            chooseTransport(Object.assign(params, this.submitForm)).then(res => {
                this.options.lesseeTypeOptions = [];
                if (res && +res.code === 0 && res.data && res.data.length) {
                    this.options.lesseeTypeArr.forEach(e => {
                        for (const i of new Set(res.data)) {
                            if (String(i) === e.value) {
                                this.options.lesseeTypeOptions.push(e);
                            }
                        }
                    });
                }
            });
        },
        transportTypeForm() {
            this.form.transType = '';
            this.handleUpdateForm();
            const params = {
                supplierType: this.row.supplierType,
                propertyNature: this.row.propertyNature,
            };
            chooseTransport(Object.assign(params, this.submitForm)).then(res => {
                this.options.transTypeOptions = [];
                if (res && +res.code === 0 && res.data && res.data.length) {
                    this.options.transTypeArr.forEach(e => {
                        for (const i of new Set(res.data)) {
                            if (String(i) === e.value) {
                                this.options.transTypeOptions.push(e);
                            }
                        }
                    });
                }
            });
        }
    },
    mounted() {
        const list = [
            { optionName: 'businessTypeArr', optionNum: 'SRM_BUSYNESS_TYPE_BACKGROUND' },
            { optionName: 'transportTypeArr', optionNum: 'SRM_TRANSPORT_TYPE' },
            { optionName: 'transTypeArr', optionNum: 'SRM_SHIPPER_TYPE' },
            { optionName: 'corporateTypeArr', optionNum: 'SU_CORPORATE_TYPE' },
            { optionName: 'lesseeTypeArr', optionNum: 'SU_LEASE_TYPE' }
        ];
        dictWithUrl('SYS_SUPPLIERS_TYPE,SYS_SUPPLIERS_PROPERTY,SRM_BUSYNESS_TYPE_BACKGROUND,SRM_TRANSPORT_TYPE,' +
            'SRM_SHIPPER_TYPE,SU_CORPORATE_TYPE,SU_LEASE_TYPE').then(res => {
            if (res && +res.code === 0) {
                list.forEach(e => {
                    const arr = [];
                    for (const key in res.data[e.optionNum]) {
                        if (res.data[e.optionNum].hasOwnProperty(key)) {
                            arr.push({
                                value: key,
                                label: res.data[e.optionNum][key]
                            });
                        }
                    }
                    this.options[e.optionName] = arr;
                });
            }
        });
    }
};
</script>

<style lang="less">
    .new_service_dialog {
        .el-dialog__body {
            padding: 16px 30% 0 0;
        }

        .normal_input {
            width: 100%;
        }
    }
</style>
